import { Button } from "@mantine/core";
import type { JSX } from "react";

interface IProps {
    tuneThread: {
        id: number;
    };
    onClear: (id: number) => void;
    disabled?: boolean;
}

function ClearButton({ tuneThread, onClear, disabled }: IProps): JSX.Element {
    return (
        <Button onClick={() => onClear(tuneThread.id)} disabled={!!disabled}>
            Clear
        </Button>
    );
}

export default ClearButton;
